import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '@core/environment/environment.service';
import {Observable} from 'rxjs';
import {TtsRequestModel} from '../text-to-speech/request/tts-request.model';
import {SetPasswordResponseEnum} from '../../../../views/public/password-set/enums/set-password-response.enum';
import {SetPasswordModel} from '../../../../views/public/password-set/model/set-password.model';

@Injectable({
    providedIn: 'root'
})
export class PubliclinkRestService {

    private controllerUrl = this.environmentService.serverApiUrl + '/public';

    constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    }

    getPublicTTS(ttsObject: TtsRequestModel): Observable<string> {
        return this.httpClient.post<string>(this.controllerUrl.concat('/tts/read'), ttsObject);
    }

    userAlreadySetPasswordCheck(validationToken: string): Observable<SetPasswordResponseEnum> {
        return this.httpClient.get<SetPasswordResponseEnum>(this.controllerUrl.concat('/user/validation-token/' + validationToken));
    }

    saveUserCredentials(userData: SetPasswordModel): Observable<void> {
        return this.httpClient.post<void>(this.controllerUrl.concat('/user/set-password'), userData);
    }

    getEmailFromToken(token: string): Observable<string> {
        return this.httpClient.get<string>(this.controllerUrl.concat('/user/email/' + token));
    }
}
